import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faUser } from '@fortawesome/pro-solid-svg-icons';
import { useState, useEffect } from 'react';
import { IdentityPlatform } from '@playcastdotio/CoreTypes';
import { faDiscord, faTwitch } from '@fortawesome/free-brands-svg-icons';

type ModalProps = {
  isOpen: boolean;
  defaultPlatform?: IdentityPlatform;
  aliases: Partial<Record<IdentityPlatform, string>> | undefined | null;
  onClose: () => void;
  onApply?: (platform: IdentityPlatform) => void;
};

export const AliasSelectionModal = ({ isOpen, onClose, defaultPlatform, aliases, onApply }: ModalProps) => {
  const [platform, setPlatform] = useState<IdentityPlatform>(defaultPlatform || IdentityPlatform.CLERK);

  useEffect(() => {
    if (defaultPlatform) {
      setPlatform(defaultPlatform);
    }
  }, [defaultPlatform]);

  const handleApply = () => {
    onClose();
    if (onApply) {
      onApply(platform);
    }
  };

  // const getPlatformDefaultName = (platform: IdentityPlatform): string => {
  //   switch (platform) {
  //     case IdentityPlatform.CLERK:
  //       return 'Username';
  //     case IdentityPlatform.TWITCH:
  //       return 'Twitch Alias';
  //     case IdentityPlatform.DISCORD:
  //       return 'Discord Alias';
  //     default:
  //       return 'Username';
  //   }
  // };

  if (!isOpen) return null;

  // Map platform to appropriate icon
  const platformIcons = {
    [IdentityPlatform.CLERK]: faUser,
    [IdentityPlatform.TWITCH]: faTwitch,
    [IdentityPlatform.DISCORD]: faDiscord,
  };

  // Only show platforms that have aliases or CLERK (default)
  const availablePlatforms = Object.values(IdentityPlatform).filter((p) => p === IdentityPlatform.CLERK || aliases?.[p]);

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50'>
      <div className='bg-darkest relative w-full max-w-xs rounded-lg p-6 text-center'>
        <button onClick={() => onClose()} className='absolute right-4 top-4 text-white hover:text-gray-300'>
          <FontAwesomeIcon icon={faXmark} className='size-6' />
        </button>
        <h2 className='mb-4 w-full text-left font-[Syne] text-2xl font-semibold text-white'>Select Alias</h2>
        <div>
          {availablePlatforms.includes(IdentityPlatform.CLERK) && (
            <div className='mb-2 flex items-center justify-between'>
              <label htmlFor='username' className='flex cursor-pointer items-center gap-2 truncate'>
                <div className='flex w-6 justify-center'>
                  <FontAwesomeIcon icon={platformIcons[IdentityPlatform.CLERK]} className='text-gray-300' />
                </div>
                <span className='truncate'>{aliases?.[IdentityPlatform.CLERK] || 'Username'}</span>
              </label>
              <input
                type='radio'
                name='alias'
                id='username'
                checked={platform === IdentityPlatform.CLERK}
                onChange={() => setPlatform(IdentityPlatform.CLERK)}
              />
            </div>
          )}
          {availablePlatforms.includes(IdentityPlatform.TWITCH) && (
            <div className='mb-2 flex items-center justify-between'>
              <label htmlFor='twitch' className='flex cursor-pointer items-center gap-2 truncate'>
                <div className='flex w-6 justify-center'>
                  <FontAwesomeIcon icon={platformIcons[IdentityPlatform.TWITCH]} className='text-purple-400' />
                </div>
                <span className='truncate'>{aliases?.[IdentityPlatform.TWITCH] || 'Twitch Alias'}</span>
              </label>
              <input
                type='radio'
                name='alias'
                id='twitch'
                checked={platform === IdentityPlatform.TWITCH}
                onChange={() => setPlatform(IdentityPlatform.TWITCH)}
              />
            </div>
          )}
          {availablePlatforms.includes(IdentityPlatform.DISCORD) && (
            <div className='mb-2 flex items-center justify-between'>
              <label htmlFor='discord' className='flex cursor-pointer items-center gap-2 truncate'>
                <div className='flex w-6 justify-center'>
                  <FontAwesomeIcon icon={platformIcons[IdentityPlatform.DISCORD]} className='text-indigo-400' />
                </div>
                <span className='truncate'>{aliases?.[IdentityPlatform.DISCORD] || 'Discord Alias'}</span>
              </label>
              <input
                type='radio'
                name='alias'
                id='discord'
                checked={platform === IdentityPlatform.DISCORD}
                onChange={() => setPlatform(IdentityPlatform.DISCORD)}
              />
            </div>
          )}
        </div>
        <button className='text-darkest mt-4 w-fit rounded-lg bg-amber-400 px-4 py-2 font-[Syne] text-lg font-bold' onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

